import L, { LatLngExpression } from 'leaflet';

const mapJsClass = 'js-map-geojson';

const mapElements = document.querySelectorAll('.' + mapJsClass) as NodeListOf<HTMLElement>;

const defaultCoordinates: LatLngExpression = [43.8338988, 4.3600284];
const defaultZoom = 15;

mapElements.forEach((mapElement) => {
    // Get zoom from data attribute
    const zoom = mapElement.dataset.zoom ? JSON.parse(mapElement.dataset.zoom) : defaultZoom;

    // Create map
    const map = L.map(mapElement, {
        zoomControl: false
    });

    // Give map a tileLayer
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: 20
    }).addTo(map);

    // Get geojson from data attribute
    const geojson = mapElement.dataset.geojson && JSON.parse(mapElement.dataset.geojson);

    if(!geojson) {
        console.error("Invalid or missing geoJSON");
        return;
    }

    L.geoJSON(geojson, {
        onEachFeature: (feature, layer) => {
            // Add popup to feature
            if (feature.properties && feature.properties.popupContent) {
                layer.bindPopup(feature.properties.popupContent);
            }
        },
        style: (feature) => {
            // Set feature color
            if (feature.properties && feature.properties.color) {
                return { color: feature.properties.color };
            }
        }
    }).addTo(map);

    // Get zoom control labels from the data attribute
    const zoomInTitle = mapElement.dataset.zoomInTitle;
    const zoomOutTitle = mapElement.dataset.zoomOutTitle;

    // Create zoom control labels
    if (zoomInTitle && zoomOutTitle) {
        L.control.zoom({
            zoomInTitle: zoomInTitle,
            zoomOutTitle: zoomOutTitle
        }).addTo(map);
    }

    // Center map
    map.setView(defaultCoordinates, zoom);
});